if (!customElements.get('feature-accordion-media')) {
  customElements.define(
    'feature-accordion-media',
    class FeatureAccordionMedia extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-feature-accordion-item]'));
        this.panels = Array.from(this.querySelectorAll('[data-feature-media-panel]'));
        this.autoplayVideos = this.dataset.videoAutoplay === 'true';
        this.loopVideos = this.dataset.videoLoop === 'true';
        this.abortController = new AbortController();
        this.stage = this.querySelector('[data-feature-media-stage]');
        this.stageHome = this.stage.parentElement;
        this.mobile = window.matchMedia('(max-width: 989px)');
        this.mobile.addEventListener('change', () => this.placeMedia(), { signal: this.abortController.signal });
        this.setupVideoControls();

        this.items.forEach((item) => {
          item.addEventListener(
            'toggle',
            () => {
              if (!item.open) {
                if (this.mobile.matches && item === this.activeItem) {
                  this.stage.querySelectorAll('video').forEach((video) => video.pause());
                }
                return;
              }
              this.activateItem(item);
            },
            { signal: this.abortController.signal }
          );
        });

        document.addEventListener(
          'shopify:block:select',
          (event) => {
            const item = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
            if (!item) return;
            item.open = true;
            this.activateItem(item);
            item.scrollIntoView({ behavior: 'smooth', block: 'center' });
          },
          { signal: this.abortController.signal }
        );

        const openItem = this.items.find((item) => item.open) || this.items[0];
        if (openItem) this.activateItem(openItem, false);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.querySelectorAll('video').forEach((video) => video.pause());
      }

      placeMedia() {
        if (!this.activeItem) return;
        if (this.mobile.matches) {
          this.activeItem.querySelector('summary').after(this.stage);
        } else {
          this.stageHome.append(this.stage);
        }
        this.classList.toggle('has-inline-media', this.mobile.matches);
      }

      setupVideoControls() {
        this.panels.forEach((panel) => {
          const video = panel.querySelector('video');
          if (!video) return;
          panel.querySelector('.feature-accordion-media__controls')?.remove();
          const controls = document.createElement('div');
          controls.className = 'feature-accordion-media__controls';
          const play = document.createElement('button');
          const sound = document.createElement('button');
          [play, sound].forEach((button) => { button.type = 'button'; controls.append(button); });
          const update = () => {
            play.textContent = video.paused ? '\u25b6' : '\u23f8';
            play.title = video.paused ? 'Play video' : 'Pause video';
            play.setAttribute('aria-label', play.title);
            sound.textContent = video.muted ? '\u266a\u00d7' : '\u266a';
            sound.title = video.muted ? 'Unmute video' : 'Mute video';
            sound.setAttribute('aria-label', sound.title);
          };
          play.addEventListener('click', () => {
            if (video.paused) video.play().catch(update);
            else video.pause();
          }, { signal: this.abortController.signal });
          sound.addEventListener('click', () => { video.muted = !video.muted; }, { signal: this.abortController.signal });
          ['play', 'pause', 'ended', 'volumechange'].forEach((name) => video.addEventListener(name, update, { signal: this.abortController.signal }));
          video.playsInline = true;
          video.controls = false;
          panel.append(controls);
          update();
        });
      }

      activateItem(activeItem, closeOthers = true) {
        this.activeItem = activeItem;
        this.placeMedia();
        if (closeOthers) {
          this.items.forEach((item) => {
            if (item !== activeItem && item.open) item.open = false;
          });
        }

        const requestedTarget = activeItem.dataset.mediaTarget || 'default';
        const requestedPanel = this.panels.find((panel) => panel.dataset.featureMediaPanel === requestedTarget);
        this.activatePanel(requestedPanel ? requestedTarget : 'default');
      }

      activatePanel(target) {
        this.panels.forEach((panel) => {
          const isActive = panel.dataset.featureMediaPanel === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
          panel.setAttribute('aria-hidden', String(!isActive));

          panel.querySelectorAll('video').forEach((video) => {
            video.autoplay = this.autoplayVideos;
            video.loop = this.loopVideos;

            if (!isActive) {
              video.pause();
              return;
            }

            if (this.autoplayVideos) {
              video.muted = true;
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      }
    }
  );
}
